import { render, staticRenderFns } from "./ExternalSystemAccess.vue?vue&type=template&id=7c05c24e&scoped=true&"
import script from "./ExternalSystemAccess.vue?vue&type=script&lang=js&"
export * from "./ExternalSystemAccess.vue?vue&type=script&lang=js&"
import style0 from "./ExternalSystemAccess.vue?vue&type=style&index=0&id=7c05c24e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c05c24e",
  null
  
)

export default component.exports